import React, { useEffect } from "react";
import FHIR from "fhirclient";
import { useParams } from "react-router-dom";
interface HealthCheckAppProps {
  aiName?:string
}

const HealthCheckApp: React.FC<HealthCheckAppProps> = ({ aiName }) => {

  useEffect(() => {
   

    FHIR.oauth2.authorize({
      clientId: "my_web_app",
      scope: "launch openid fhirUser patient/*.read",
      redirectUri: `https://stage.ehrconnect.healthconnect.systems/healthconnect-ai-${aiName}/NjAyNmNjNTUtYWY2YS00OTk1LWE2YTAtMDVlNTM1ZTA4NTYxLDE3MjQyNzRhODdhMjcxZjViNWI0NzFjMTBhZDU2YjE3YjljOWFkMmQxYWRiMzdlOTNlMDMxZmE4ZDZmNDAzM2I%3D`,
    });
  }, []);

  return <div>{/* <h1>Launching HealthCheck App..</h1> */}</div>;
};

export default HealthCheckApp;
